export function generateGeoJSONObject(id, lng, lat, name, properties) {
  const geoJSONObject = {
    type: "Feature",
    id: id,
    geometry: {
      type: "Point",
      coordinates: [lng, lat],
    },
    // properties: {
    //   id: id,
    //   name: name,
    //   markerElement: markerElement,
    // },
    properties: { id, name, ...properties },
  };

  return geoJSONObject;
}
